import type { ComputedRef, InjectionKey, WritableComputedRef } from 'vue'

export interface JdPaginationContext {
  currentPage?: WritableComputedRef<number>
  pageCount?: ComputedRef<number>
  disabled?: ComputedRef<boolean>
  changeEvent?: (val: number) => void
  handleSizeChange?: (val: number) => void
}

export const jdPaginationKey: InjectionKey<JdPaginationContext> =
  Symbol('PaginationKey')
